import { NgModule } from "@angular/core";
import { AutoMapperService } from "../../../services/Common/auto-mapper.service";
import { AdminCommonModule } from "../../admin/admin-common.module";
import { BillsTableComponent } from "./bills-table.component";

@NgModule({
    declarations: [
        BillsTableComponent
    ],
    imports: [
        AdminCommonModule
    ],
    exports: [
        BillsTableComponent
    ],
    providers: [
        AutoMapperService
    ]
})
export class BillsTableModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/bills-table/bills-table.module.ts